let selector={
  'email_pattern':/^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/,
  'name_pattern': /^[A-Za-z\s\-]+$/,
  'phone_pattern': /^[0-9]+$/,
  'zip_pattern': /^[0-9-a-z-A-Z]+$/,
  'handle' : (location.href).split('/')[4]
},
initialiseSelectors = (selector, handle) => {
  if(document.querySelector('[action="/contact#footer_newsletter_newsletter"]')){
    let form=document.querySelector('[action="/contact#footer_newsletter_newsletter"]'), 
    submitBtn=form.querySelector('button'), 
    inputField=form.querySelector('[name="contact[email]"]');
    
    createErrorContainer(form, 0);
    addEventsToSingleField(form, submitBtn, inputField, selector);
  }
  switch(handle){
    case 'login': {
      ['[action="/account/login"]', '[action="/account/recover"]'].forEach((formSelector, index)=>{
        let form = document.querySelector(formSelector),
        submitBtn=form.querySelector('button'),
        inputFields=(index==0)?(form.querySelectorAll('[name*=customer]')):(form.querySelector('[name="email"]'));
        createErrorContainer(form, index);
        (index==0)?(addEventsToMultipleFields(form, submitBtn, inputFields, selector, 'customer')):(addEventsToSingleField(form, submitBtn, inputFields, selector));
      });
      break;
    }
    case 'register': {
      let form = document.querySelector('[action="/account"]'),
      submitBtn=form.querySelector('button'),
      inputFields= form.querySelectorAll('[name*=customer]');
      createErrorContainer(form, 0);
      addEventsToMultipleFields(form, submitBtn, inputFields, selector, 'customer');
      break;
    }
    case 'addresses': {
      let form=document.querySelector('[action="/account/addresses"]'),
      submitBtn=form.querySelector('button'),
      inputFields= form.querySelectorAll('[name*=address]');
      createErrorContainer(form, 0);
      addEventsToMultipleFields(form, submitBtn, inputFields, selector, 'address');
      break;
    }
    case 'contact-us': {
      /**
       * here we need to add custom class to contact us form because there can be multiple Contact forms including footer newsletter and newsletter popups
       */
      let form=document.querySelector('form[action*="/contact"]'),
      submitBtn=form.querySelector('button'),
      inputFields= form.querySelectorAll('[name*=contact]');
      createErrorContainerContact(form, 0);
      addEventsToMultipleFields(form, submitBtn, inputFields, selector, 'contact');
      break;
    }
    case 'reset': {
      let form=document.querySelector('[action="/account/reset"]'),
      submitBtn=form.querySelector('button'),
      inputFields= form.querySelectorAll('[name*=customer]');
      createErrorContainer(form, 0);
      addEventsToMultipleFields(form, submitBtn, inputFields, selector, 'customer');
      break;
    }
    case 'login#recover': {
      initialiseSelectors(selector, 'login');
      break;
    }
    case 'contact': {
      initialiseSelectors(selector, 'contact-us');
      break;
    }
    case 'support': {
      initialiseSelectors(selector, 'contact-us');
      break;
    }
  }

},
createErrorContainerContact = (form, index) =>{
  let errorHtml=`<span class="form--error">**Email is required</span>`,
    styleHtml=`<style>.form--error-container{color:red;text-align:center;font-size:14px;margin-bottom:24px;background:#fdf0f0;padding:8px 10px;display:flex;justify-content:flex-start}.error-svg-container{margin-right:10px}.hide{display:none!important}[type=submit]:disabled{cursor:not-allowed!important}</style>`;
  (index==0)?(document.head.innerHTML+=styleHtml):(document.head.innerHTML+='');
  const newNode = document.createElement("div");
  newNode.classList.add('form--error-container', 'hide', 'form-status-list');
  document.querySelector('.contact-page-content').insertBefore(newNode, form.querySelector('.form-fields-columns'));
  form.querySelector('.form--error-container').innerHTML=errorHtml;
},
createErrorContainer = (form, index) =>{
  let errorHtml=`<span class="form--error">**Email is required</span>`,
    styleHtml=`<style>.form--error-container{color:red;text-align:center;font-size:14px;margin-bottom:24px;background:#fdf0f0;padding:8px 10px;display:flex;justify-content:flex-start}.error-svg-container{margin-right:10px}.hide{display:none!important}[type=submit]:disabled{cursor:not-allowed!important}</style>`;
  (index==0)?(document.head.innerHTML+=styleHtml):(document.head.innerHTML+='');
  const newNode = document.createElement("div");
  newNode.classList.add('form--error-container', 'hide', 'form-status-list');
  form.insertBefore(newNode, form.querySelectorAll('input')[0]);
  form.querySelector('.form--error-container').innerHTML=errorHtml;
},
addEventsToMultipleFields = (form, button, inputFields, selectors, formType) => {
  disableSubmitBtn(button, true);
  inputFields.forEach((field)=>{
    let fieldType=(field.getAttribute('name').split(formType+'[')[1]).split(']')[0];
    (['last_name', 'first_name', 'email', 'name', 'country', 'city', 'phone', 'address1', 'zip', 'password', 'password_confirmation', 'spam', 'Comment'].includes(fieldType))?((['last_name', 'country'].includes(fieldType))?(field.setAttribute('data-status', 'true')):(field.setAttribute('data-status', 'false'))):(field.setAttribute('no-status', ''));
    ['input', 'blur', 'change'].forEach(evt => {
      field.addEventListener(evt, (e)=>{
        validateDetails(form, button, e.currentTarget, selector, fieldType);
      });
    });
  });
  setTimeout(()=>{
    console.log("Clicked");
    inputFields[0].focus();
  }, 2000);
},
addEventsToSingleField = (form, button, inputField, selectors) =>{
  disableSubmitBtn(button, true);
  ['input', 'blur', 'change'].forEach(evt => {
    inputField.addEventListener(evt, (e)=>{
      validateDetails(form, button, e.currentTarget, selector, 'email');
    })
  })
},
disableSubmitBtn = (button, status) => {
  (status)?(button.setAttribute('disabled','')):(button.removeAttribute('disabled'));
},
validateDetails = (form, button, field, selectors, type) => {
  let isBlank=(field.value=='')?(true):(false),
  errorSpan = form.querySelector('.form--error-container .form--error');
  
  switch(type){
    case 'email': {
      let isInvalidString = (!field.value.match(selectors.email_pattern) || field.value.match(selectors.phone_pattern))?(true):(false);
      (isBlank)?(manageError('Email required', errorSpan, field, button, form)):((isInvalidString)?(manageError('Invalid Email.', errorSpan, field, button, form)):(manageError('', errorSpan, field, button, form)));
      break;
    }
    case 'password': {
      let isShortString=(field.value.length<8)?(true):(false),
      isResetPasswordError=((selectors.handle=='reset') && ((form.querySelector('[name="customer[password_confirmation]"]').value).length>7))?(true):(false);
      (isBlank)?(manageError('Password required', errorSpan, field, button, form)):((isShortString)?(manageError('Min. 8 characters required', errorSpan, field, button, form)):(manageError('', errorSpan, field, button, form), (isResetPasswordError)?(validateDetails(form, button, form.querySelector('[name="customer[password_confirmation]"]'), selectors, 'password_confirmation')):(console.log())));
      break;
    }
    case 'first_name': {
      let isInvalidString=(!field.value.match(selectors.name_pattern))?(true):(false),
      isShortString=(field.value.length<3)?(true):(false);
      (isBlank)?(manageError('First Name is required', errorSpan, field, button, form)):((isInvalidString)?(manageError('Invalid name', errorSpan, field, button, form)):((isShortString)?(manageError('Min. 3 characters required', errorSpan, field, button, form)):(manageError('', errorSpan, field, button, form))));
      break;
    }
    case 'last_name': {
      let isInvalidString=(!field.value.match(selectors.name_pattern))?(true):(false);
      (isBlank)?(manageError('', errorSpan, field, button, form)):((isInvalidString)?(manageError('Invalid Last name', errorSpan, field, button, form)):(manageError('', errorSpan, field, button, form)));
      break;
    }
    case 'phone': {
      let isInvalidString=(!field.value.match(selectors.phone_pattern))?(true):(false),
      isInvalidlength=(field.value.length < 8 || field.value.length > 15)?(true):(false);
      (isBlank)?(manageError('Phone is required', errorSpan, field, button, form)):((isInvalidString)?(manageError('Invalid Phone Number', errorSpan, field, button, form)):((isInvalidlength)?(manageError('Digit count should be between 8-15', errorSpan, field, button, form)):(manageError('', errorSpan, field, button, form))));
      break;
    }
    case 'address1': {
      let isShortString=(field.value.length<3)?(true):(false);
      (isBlank)?(manageError('Address is required', errorSpan, field, button, form)):((isShortString)?(manageError('Min. 3 characters required', errorSpan, field, button, form)):(manageError('', errorSpan, field, button, form)));
      break;
    }
    case 'city': {
      let isInvalidString=(!field.value.match(selectors.name_pattern))?(true):(false),
      isShortString=(field.value.length<3)?(true):(false);
      (isBlank)?(manageError('City is required', errorSpan, field, button, form)):((isInvalidString)?(manageError('Invalid City', errorSpan, field, button, form)):((isShortString)?(manageError('Min. 3 characters required', errorSpan, field, button, form)):(manageError('', errorSpan, field, button, form))));
      break;
    }
    case 'zip': {
      let isInvalidString=(!field.value.match(selectors.zip_pattern))?(true):(false),
      isShortString=(field.value.length<3)?(true):(false);
      (isBlank)?(manageError('Zip Code is required', errorSpan, field, button, form)):((isInvalidString)?(manageError('Invalid Zip Code', errorSpan, field, button, form)):((isShortString)?(manageError('Min. 3 characters required', errorSpan, field, button, form)):(manageError('', errorSpan, field, button, form))));
      break;
    }
    case 'country': {
      let isInvalidString=(field.value.includes('-'))?(true):(false);
      (isInvalidString)?(manageError('Select Country', errorSpan, field, button, form)):(manageError('', errorSpan, field, button, form));
      break;
    }
    case 'name': {
      validateDetails(form, button, field, selectors, 'first_name');
      break;
    }
    case 'spam':{
      let spamNum1 = +field.getAttribute('data-num1');
      let spamNum2 = +field.getAttribute('data-num2');
      let fieldValue = +field.value;
      isBlank ? manageError("Spam is required", errorSpan, field, button, form) : fieldValue !== (spamNum1+spamNum2) ? manageError("Error: Invalid spam challenge response. Please enter SPAM challenge result.", errorSpan, field, button, form) : manageError('', errorSpan, field, button, form)
      break;
    }
    case 'Comment':{
      isBlank ? manageError("Comment is required", errorSpan, field, button, form) : manageError('', errorSpan, field, button, form);
      break;
    }
    case 'password_confirmation': {
      let isShortString=(field.value.length<8)?(true):(false),
      isNotSame = ((form.querySelector('[name="customer[password]"]').value)!=field.value)?(true):(false);
      (isBlank)?(manageError('Confirm password required', errorSpan, field, button, form)):((isShortString)?(manageError('Min. 8 characters required', errorSpan, field, button, form)):((isNotSame)?(manageError('Both passwords should be same', errorSpan, field, button, form)):(manageError('', errorSpan, field, button, form))));
      break;
    }
  }
},
manageError = (message, errorSpan, field, button, form) => {
  (message.trim()!='')?(errorSpan.innerHTML=message, field.setAttribute('data-status', 'false'), errorSpan.parentElement.classList.remove('hide'), disableSubmitBtn(button, true)):(errorSpan.innerHTML='', field.setAttribute('data-status', 'true'), errorSpan.parentElement.classList.add('hide'), checkStatus(form, button));
  let fieldId = field .getAttribute('id');
  let fieldLabel = form.querySelector('[for="'+fieldId+'"]');
  (message.trim()!='') ? fieldLabel.classList.add('label-error') : fieldLabel.classList.remove('label-error');
},
checkStatus = (form, button) => {
  let inputFields=form.querySelectorAll('[data-status]'), trueStatus=0;
  inputFields.forEach((field)=>{
    (field.getAttribute('data-status')=='true')?(trueStatus+=1):(trueStatus+=0);
  });
  (trueStatus==inputFields.length)?(disableSubmitBtn(button, false)):(disableSubmitBtn(button, true));
};
initialiseSelectors(selector, selector.handle);